import { ParameterType } from '@/study-search/enums';
import { SpecialProgrammesFilterOptionValue } from '@studyportals/search-filters';
import { TitleBase } from './TitleBase';

export default class TitleSpecialProgrammesJointProgrammes extends TitleBase {
	protected canHandle(): boolean {
		return (
			this.indexableFilters.length === 1 &&
			this.indexableFilters.some(
				(_) =>
					_.type === ParameterType.SPECIAL_PROGRAMMES &&
					(_.values[0] as SpecialProgrammesFilterOptionValue) === SpecialProgrammesFilterOptionValue.JOINT_PROGRAMMES
			)
		);
	}

	protected getPageTitle(): string {
		return `Joint ${this.titlePortalType} from around the world`;
	}

	protected getMetaTitle(): string {
		return `Find ${this.totalSearchResults} joint ${this.titlePortalType}`;
	}

	protected getMetaDescription(): string {
		return (
			`Discover worldwide joint master's programs with ${this.portalName}. ` +
			`Broaden your horizons by studying for your ${this.titlePortalType} from two universities.`
		);
	}
}
